//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    components: { },
    props: {
        action:{
            type: String,
            default: '/bhtong/common/file/uploadFile'
        },
        filename:{
            type:String,
            default:''
        },
        mubanShow:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            fileList:[]
        }
    },
    computed: {
  
    },
    watch:{
        filename:function(n,o){
            if(!n){ return }

            var new_name = n.slice(33);

            if(n.length > 63){
                new_name = n.slice(63);
            }

            if(new_name){
                this.fileList.push({ name:new_name, url: n })
            }
        } 
    },
    methods: {

        //点击打开文件
        handlePreview(file) {
            var val ='';
            if(file.url){
                val = file.url
            }else{
                val = file.response.tdata
            }
            // var search = toSearch({
            //     fileName:val
            // });
            // debugger
            
            if(!!val.fileUrl && val.fileUrl.indexOf('http:') != -1){
                window.open(val.fileUrl);
                return
            }else{
                // window.open('/bhtong/common/file/download' + search);
            }

            // 新 改变了返回值以后的预览情况
            if(typeof file.url === 'string'){
                window.open(file.url);
                return
            }
            //刚上传 成功，没有提交
            if(file.response.tdata.fileUrl){
                window.open(file.response.tdata.fileUrl);
                return
            }
        },
        beforeUpload:function(file){
            let filesize = file.size / 1024 / 1024 
            if (filesize > 10) {
              this.$message.warning('上传文件大小不能超过 10MB!');
              return false
            }
        },
        //上传成功时
        uploadSuccess:function(response, file,fileList){
            this.$emit('setfile',response.tdata);
        },

        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，请移除当前文件后，在进行上传`);
        },
        //文件移除之前
        beforeRemove(file, fileList) {
            if(file && file.status === 'success'){
                return this.$confirm(`确定移除 ${ file.name }？`);
            }
        },
        //文件移除时
        handleRemove(file, fileList) {
            this.$emit('setfile','');
            this.fileList = []
        },
    },
    mounted:function(){

    }
}
